import { configs } from "../services/configs"

const fileServer = configs.fileServer;

export const formatImageUrl = (uri) => {
    if(window.location.origin === 'http://localhost:3000') {
        return `http://localhost/kevotelecom/${uri}`
    }
    return `${fileServer}/${uri}`
};